// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_r4-0";